import { useEffect, useState } from 'react';

/** Khổ rộng (≥ 1800, như các board `-1920`): cột phải của màn mở sẵn và cố định. */
export const useWide = (): boolean => useMedia('(min-width: 1800px)');

/** Khổ iPad (≤ 1240, như các board `-iPad`): bản rút gọn của trang chi tiết. */
export const useTablet = (): boolean => useMedia('(max-width: 1240px)');

function useMedia(q: string): boolean {
  const [w, setW] = useState(() => typeof window !== 'undefined' && window.matchMedia(q).matches);
  useEffect(() => {
    const m = window.matchMedia(q);
    const on = () => setW(m.matches);
    m.addEventListener('change', on);
    return () => m.removeEventListener('change', on);
  }, []);
  return w;
}
